<h1 class="font-semibold my-4 title text-dark-purple {{additionalClasses}}">
  {{title}}
</h1>

